<template>
  <div class="basic_wrap">
    <!-- 顶部紫色渐变头部 -->
       <!-- 顶部紫色渐变头部 -->
       <div
         style="width: 100%;height: 136px;background: linear-gradient(to bottom right, #6d28d9,#d946ef, #f472b6);padding-top: 14px;padding-bottom: 28px;padding-left: 14px;padding-right: 14px;"
       >
         <!-- 关键修改：用 flex 把返回按钮和标题包在一起 -->
         <div style="display: flex; align-items: center; position: relative; height: 32px;">
           <!-- 返回按钮 -->
           <div
             style="padding-left: 8px;padding-top: 8px;background-color: #4c1d9566;border-radius: 7px;height: 28px;width: 28px;align-items: center;justify-content: center;display:flex; flex-shrink: 0;"
             @click="$router.back()"
           >
             <svg
               style="font-size: 12px;line-height: 18px;color:#fff;display:inline-block;height: 12px;"
               aria-hidden="true"
               focusable="false"
               data-prefix="fas"
               data-icon="chevron-left"
               class="svg-inline--fa fa-chevron-left text-white"
               role="img"
               xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 320 512"
             ><path
               fill="currentColor"
               d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
             /></svg>
           </div>
           
           <!-- 标题文字（去掉了 top:14px 的绝对定位，改为 flex 自动居中） -->
           <div style="padding-left: 8px;">
             <div style="width: 100%;height: 26px;line-height: 26px;font-size: 14px;font-weight: 600;color:#fff">
               {{ $t('utils.lunlog1') }}
             </div>
             <div style="width: 100%;height: 14px;line-height: 14px;font-size: 10px;font-weight: 400;color:#fff">
               {{ $t('utils.lunlog2') }}
             </div>
           </div>
         </div>
   
         <!-- 奖金区域 -->
         <div
           style="width: 100%;text-align: center;height: 36px;margin-top: 15px;background-color: #ffffff26;border-radius: 14px;align-items: center;padding:12px"
         >
           <!-- ... 中间 SVG 和奖金文字部分完全不变，保持原样 ... -->
           <svg
             style="font-size: 12px;line-height: 12px;color:rgb(252 211 77/1);display:inline-block;height: 12px;"
             aria-hidden="true"
             focusable="false"
             data-prefix="fas"
             data-icon="gift"
             class="svg-inline--fa fa-gift text-amber-300 text-sm"
             role="img"
             xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 512 512"
           ><path
             fill="currentColor"
             d="M190.5 68.8L225.3 128l-1.3 0-72 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8zM64 88c0 14.4 3.5 28 9.6 40L32 128c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-41.6 0c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0L152 0C103.4 0 64 39.4 64 88zm336 0c0 22.1-17.9 40-40 40l-72 0-1.3 0 34.8-59.2C329.1 55.9 342.9 48 357.8 48l2.2 0c22.1 0 40 17.9 40 40zM32 288l0 176c0 26.5 21.5 48 48 48l144 0 0-224L32 288zM288 512l144 0c26.5 0 48-21.5 48-48l0-176-192 0 0 224z"
           /></svg>
           <span class="text-white text-sm font-medium">
             <span style="font-size: 12px;color:#ffff;font-weight: 500;">
               {{ $t('utils.lunlog3') }}{{ common.currency_symbol_basic() }}{{ min }} – {{ common.currency_symbol_basic() }}{{ max }}
             </span>
           </span>
           <svg
             style="font-size: 12px;line-height: 12px;color:rgb(252 211 77/1);display:inline-block;height: 12px;"
             aria-hidden="true"
             focusable="false"
             data-prefix="fas"
             data-icon="coins"
             class="svg-inline--fa fa-coins text-amber-300 text-sm"
             role="img"
             xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 512 512"
           ><path
             fill="currentColor"
             d="M512 80c0 18-14.3 34.6-38.4 48c-29.1 16.1-72.5 27.5-122.3 30.9c-3.7-1.8-7.4-3.5-11.3-5C300.6 137.4 248.2 128 192 128c-8.3 0-16.4 .2-24.5 .6l-1.1-.6C142.3 114.6 128 98 128 80c0-44.2 86-80 192-80S512 35.8 512 80zM160.7 161.1c10.2-.7 20.7-1.1 31.3-1.1c62.2 0 117.4 12.3 152.5 31.4C369.3 204.9 384 221.7 384 240c0 4-.7 7.9-2.1 11.7c-4.6 13.2-17 25.3-35 35.5c0 0 0 0 0 0c-.1 .1-.3 .1-.4 .2c0 0 0 0 0 0s0 0 0 0c-.3 .2-.6 .3-.9 .5c-35 19.4-90.8 32-153.6 32c-59.6 0-112.9-11.3-148.2-29.1c-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-34.8 53.4-64.5 128-75.4c10.5-1.5 21.4-2.7 32.7-3.5zM416 240c0-21.9-10.6-39.9-24.1-53.4c28.3-4.4 54.2-11.4 76.2-20.5c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 19.3-16.5 37.1-43.8 50.9c-14.6 7.4-32.4 13.7-52.4 18.5c.1-1.8 .2-3.5 .2-5.3zm-32 96c0 18-14.3 34.6-38.4 48c-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336l0-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352s108.6-9.4 148.1-25.9c7.8-3.2 15.3-6.9 22.4-10.9c6.1-3.4 11.8-7.2 17.2-11.2c1.5-1.1 2.9-2.3 4.3-3.4l0 3.4 0 5.7 0 26.3zm32 0l0-32 0-25.9c19-4.2 36.5-9.5 52.1-16c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 10.5-5 21-14.9 30.9c-16.3 16.3-45 29.7-81.3 38.4c.1-1.7 .2-3.5 .2-5.3zM192 448c56.2 0 108.6-9.4 148.1-25.9c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 44.2-86 80-192 80S0 476.2 0 432l0-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448z"
           /></svg>
         </div>
       </div>

    <!-- 表单卡片区域 -->
    <div style="width: 100%;margin-top: -7px;padding: 0 14px 40px 14px;">
      <div style="width:100%">
        <!-- 卡片1：提现 -->
        <div
          style="margin-top: 14px;background: #f1f5f9;width: 100%;padding:14px;border-radius: 14px;border: 1px solid #e2e8f0;"
        >
          <div style="gap:7px;align-items: center;display: flex;margin-bottom:10px">
            <div style="background-color: #8b5cf6cc;line-height: 24px;border-radius: 50%;height: 24px;color:#fff;width:24px;text-align: center;">
              1
            </div>
            <span style="color:#1e293b;font-weight:600;">{{ $t('user.withdraw') }}</span>
          </div>
          <select
            id="withdrawalSelect"
            v-model="wid" 
            style="border-radius:10px;height: 44px;width:100%;border:1px solid #e2e8f0;background-color: #ffffff;color:#1e293b;font-size: 12px;line-height:18px;padding:0 10px;"
          >
            <option value="" style="color:#64748b;">
              {{ $t('utils.lunlog4') }}
            </option>
            <option
              v-for="(item,index) in lists"
              :key="index"
              :value="item.id"
              style="color:#1e293b;"
            >
              {{ $t('user.withdraw') }}: {{ common.currency_symbol_basic() }} {{ item.money }}
            </option>
          </select>
          <div v-if="count==0" style="gap:7px;align-items: center;display: flex;margin-top:10px;color:#64748b;">
            <span style="width: 24px;height: 24px;padding: 6px;">
              <svg
                style="font-size: 12px;line-height: 12px;color:#64748b;display:inline-block;height: 12px;"
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="receipt"
                class="svg-inline--fa fa-receipt text-slate-500"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 384 512"
              ><path
                fill="currentColor"
                d="M14 2.2C22.5-1.7 32.5-.3 39.6 5.8L80 40.4 120.4 5.8c9-7.7 22.3-7.7 31.2 0L192 40.4 232.4 5.8c9-7.7 22.3-7.7 31.2 0L304 40.4 344.4 5.8c7.1-6.1 17.1-7.5 25.6-3.6s14 12.4 14 21.8l0 464c0 9.4-5.5 17.9-14 21.8s-18.5 2.5-25.6-3.6L304 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L192 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L80 471.6 39.6 506.2c-7.1 6.1-17.1 7.5-25.6 3.6S0 497.4 0 488L0 24C0 14.6 5.5 6.1 14 2.2zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 144zM80 352c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 336c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 240z"
              /></svg>
            </span>
            <span>{{ $t('utils.lunlog5') }}</span>
          </div>
        </div>

        <!-- 卡片2：上传提款证明 -->
        <div
          style="margin-top: 14px;background: #f1f5f9;width: 100%;padding:14px;border-radius: 14px;border: 1px solid #e2e8f0;"
        >
          <div style="gap:7px;align-items: center;display: flex;margin-bottom:10px">
            <div style="background-color: #8b5cf6cc;line-height: 24px;border-radius: 50%;height: 24px;color:#fff;width:24px;text-align: center;">
              2
            </div>
            <span style="color:#1e293b;font-weight:600;">{{ $t('utils.lcode6') }}</span>
          </div>
          <div
            class="recharge_voucher_wrap block_div"
            style="background-color: #ffffff;border-radius: 8px;border: 1px dashed #94a3b8;padding: 20px;"
          >
            <div class="qrcode">
              <van-uploader
                v-model="fileList"
                multiple
                :max-count="1"
                class="upload"
                :max-size="2 * 1024 * 1024"
                :after-read="afterRead"
                :before-read="beforeRead"
                @oversize="onOversize"
              />
            </div>
            <p style="width: 100%;text-align: center;color:#1e293b;line-height: 18px;">
              {{ $t('utils.lunlog7') }}
            </p>
            <p style="width: 100%;text-align: center;color:#64748b;line-height: 24px;">
              {{ $t('wallet.qrcodeError') }}
            </p>
          </div>
        </div>

        <!-- 卡片3：备注 -->
        <div
          style="margin-top: 14px;background: #f1f5f9;width: 100%;padding:14px;border-radius: 14px;border: 1px solid #e2e8f0;"
        >
          <div style="gap:7px;align-items: center;display: flex;margin-bottom:10px">
            <div style="background-color:#94a3b8;line-height: 24px;border-radius: 50%;height: 24px;color:#fff;width:24px;text-align: center;">
              3
            </div>
            <span style="width: 24px;height: 24px;padding: 6px;color:#1e293b;">
              <svg
                style="font-size: 12px;line-height: 12px;color:#1e293b;display:inline-block;height: 12px;"
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="pen-to-square"
                class="svg-inline--fa fa-pen-to-square"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              ><path
                fill="currentColor"
                d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"
              /></svg>
            </span>
            <span style="color:#1e293b;font-weight:600;">{{ $t('utils.lunlog9') }}</span>
          </div>
          <textarea 
            id="note"
            v-model="content"
            style="resize: none;width:100%;color:#1e293b;font-size: 12px;line-height: 18px;padding: 10px 14px;background-color: #ffffff;border-radius: 10px;border: 1px solid #e2e8f0;"
            maxlength="200" 
            rows="3"
            :placeholder="$t('utils.lunlog10')"
          />
        </div>

        <!-- 底部提示 -->
        <div
          style="margin-top: 14px;background: #ede9fe;width: 100%;padding:14px;border-radius: 14px;border: 1px solid #c4b5fd;"
        >
          <div style="display: flex;align-items: flex-start;gap:10px;">
            <div style="display: flex;justify-content: center;flex-shrink: 0;align-items: center;height: 28px;background-color: #c084fc;border-radius: 7px;padding: 8px;width:28px;">
              <svg
                style="font-size: 12px;line-height: 12px;color:#fff;display:inline-block;height: 12px;"
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="circle-info"
                class="svg-inline--fa fa-circle-info"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              ><path
                fill="currentColor"
                d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
              /></svg>
            </div>
            <div style="color:#4c1d95;">
              <p style="line-height: 14px;margin-bottom: 3px;font-size: 10px;font-weight: 400;">
                • {{ $t('utils.lunlog11') }}
              </p>
              <p style="line-height: 14px;margin-bottom: 3px;font-size: 10px;font-weight: 400;">
                • {{ $t('utils.lunlog12') }}
              </p>
            </div>
          </div>
        </div>

        <!-- 底部按钮 -->
        <div style="display: flex;gap:10px;margin-top:15px;height: 48px;">
          <div
            style="color:#1e293b;font-weight: 600;flex: 1 1 0%;border-radius: 14px;height: 48px;background-color: #ffffff;line-height: 48px;text-align: center;font-size: 14px;font-weight: 600;border:1px solid #e2e8f0;"
            @click="$router.back()"
          >
            {{ $t('utils.code7') }}
          </div>
          <div
            style="color:#fff;font-weight: 600;flex: 1 1 0%;border-radius: 14px;height: 48px;background:linear-gradient(to right, #6d28d9, #d946ef);line-height: 48px;text-align: center;font-size: 14px;font-weight: 600;"
            @click="playcode()"
          >
            {{ $t('utils.lcode4') }}
          </div>
        </div>
      </div>
    </div>
	<div style="height: 60px;"></div>
  </div>
</template>

<script>
import Vue from 'vue';
import bsHeader from '../../components/bsHeader.vue'
import Fetch from '../../utils/fetch'
import Api from "../../interface/index";
import axios from 'axios'
import Clipboard from "v-clipboard";
import { Uploader, Toast, Field } from "vant";

Vue.use(Uploader).use(Toast).use(Field).use(Clipboard);

export default {
  name: "LunUp",
  data() {
    return {
      lists: [],
      report: {
        "direct_count": 0,
        "indirect_count": 0,
        "income": 0,
        "income_to": 0,
        "income_ye": 0,
        "add_count": 0,
        "add_count_to": 0,
        "add_count_ye": 0
      },
      show_share: false,
      wid: "",        // 修复 v-model 绑定
      actives:1,
      empty: false,
      loading: false,
      finished: false,
      min:1000,
      max:5000,
      count:0,        // 修复默认数字
      imgs:0,
      img:"",
      fileList: [],
      code:"",
      voucher: '',
      content:"",
    };
  },
  created() {
    if (window.plus) {
      plus.navigator.setStatusBarBackground('#0F6EFF');
      plus.navigator.setStatusBarStyle('light');
    }
    this.$parent.footer('lun');
  },
  mounted() {
    this.start();
  },
  methods: {
    playcode(){
      if(this.wid == ''){
        this.$toast(this.$t('utils.lunlog4'));
        return false;
      }
      if(this.voucher == ''){
        this.$toast(this.$t('utils.lunlog13'));
        return false;
      }
      Fetch('/user/lunup', {
        wid:this.wid,
        voucher:this.voucher,
        content:this.content
      }).then(r => {
        if(r.code == '218'){
          this.$toast(this.$t(r.info));
          return false;
        }else{
          this.$toast(this.$t('utils.lunlog14'));
          this.$router.replace('/lun');
          return false;
        }
      })
    },
    quxiao(){
      this.imgs=0;
    },
    chankan(e){
      this.img=e;
      this.imgs=1;
    },
    start() {
      Fetch('/user/tikuan_log').then((r) => {
        this.lists = r.data.list;
        this.count = r.data.count;
        this.min = r.data.min;
        this.max = r.data.max;
      });
    },
    copy() {
      this.$toast(this.$t('recharge.copySuccess'));
    },
    onOversize(file) {
      this.$toast(this.$t('wallet.qrcodeLong'));
    },
    beforeRead(file) {
      if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
        this.$toast(this.$t('wallet.qrcodeError'));
        return false;
      }
      return true;
    },
    afterRead(file) {
      let formData = new FormData();
      formData.append('language', this.$i18n.locale || "id_id");
      formData.append('file', file.file);
      formData.append('token', localStorage.getItem('token'));
      Toast.loading({
        forbidClick: true,
        duration: 20000
      });
      axios.post(Api.commonUrl + "/api/user/imgUpload", formData).then((r) => {
        Toast.clear();
        if (r.data.code === 1) {
          this.voucher = r.data.data;
        } else {
          this.$toast(this.$t(r.data.info));
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.basic_wrap {
  margin-bottom: 60px;
  background: linear-gradient(180deg, #f8fbff, #eef4fb 42%, #f6f8fc);
  min-height: 100vh;
}
.top_header {
  justify-content: space-between;
  margin-bottom: 10px;
  background: #0F6EFF;
  width: 100%;
  margin: 0;
  border-radius: 0;
  color: #FFFFFF;
  height: 240px;
}
.recharge_voucher_wrap {
  margin-bottom: 10px;
  padding: 20px;

  .recharge_money {
    margin-bottom: 20px;
    p { margin-bottom: 10px; }
    .money { font-size: 18px; font-weight: bold; }
    .currency { color: #999; }
  }
  p { color: #999; }
  .qrcode {
    text-align: center;
    margin-top: 20px;
  }
}
</style>